<template>
	<div class="small-12 addForm editResident animated fadeInRight border-top border-right" v-if="open_menu" v-bind:class="{ active: open_menu }">
        <div class="small-12 columns panelMenuWrapper" v-if="resident">
            <div class="small-12 formTitle border-bottom">
                <h2 class="small-12 flex vertical-align justify-between">
					<span class="float-left small-8">
						Edit Resident
					</span>
					<i class="material-icons-outlined transition" @click="closeEditResidentMenu()">cancel</i>
				</h2>
                <div class="small-12">
					<ul class="small-12 flex vertical-align float-left attributes">
						<li>
							<p>
								<b>Resident: </b>
								{{ resident.attributes.contact_information.first_name }} {{ resident.attributes.contact_information.last_name }}
							</p>
						</li>
					</ul>
				</div>	
            </div>
            <div class="small-12 formBody" style="padding-top:20px;">
                <div class="small-12 sectionTitle flex" style="margin-top:0;">
					<h2>Resident Information</h2>
				</div>
                <fieldset class="small-12 flex inputGroup">
					<label class="small-12">First Name<em class="cRed">*</em></label>
					<input type="text" placeholder="e.g. John" v-model="first_name.value" @input="firstNameValidation($event)">
					<div class="small-12 inputError flex animated fadeInDown borderRadius2" style="margin-top:5px;" v-if="first_name.error.show">
						<small class="cRed small-12">{{first_name.error.title}}</small>
					</div>
				</fieldset>
                <fieldset class="small-12 flex inputGroup">
					<label class="small-12">Last Name<em class="cRed">*</em></label>
					<input type="text" placeholder="e.g. Bgoode" v-model="last_name.value" @input="lastNameValidation($event)">
					<div class="small-12 inputError flex animated fadeInDown borderRadius2" style="margin-top:5px;" v-if="last_name.error.show">
						<small class="cRed small-12">{{last_name.error.title}}</small>
					</div>
				</fieldset>
                <div class="small-12 sectionTitle flex">
					<h2>Contact Information</h2>
				</div>
                <fieldset class="small-12 flex inputGroup">
					<label class="small-12">Email<em class="cRed" v-if="enrolled.value">*</em></label>
					<input type="text" placeholder="e.g. johnnybgoode@example.com" v-model="email.value" @input="emailValidation($event)">
					<div class="small-12 inputError flex animated fadeInDown borderRadius2" style="margin-top:5px;" v-if="email.error.show">
						<small class="cRed small-12">{{email.error.title}}</small>
					</div>
				</fieldset>
                <fieldset class="small-12 flex inputGroup">
					<label class="small-12">Phone Number</label>
					<input type="tel" name="phone" pattern="[0-9]{3}-[0-9]{2}-[0-9]{3}" placeholder="e.g. (920) 555-1234" v-model="phone.value">
					<div class="small-12 inputError flex animated fadeInDown borderRadius2" style="margin-top:5px;" v-if="phone.error.show">
						<small class="cRed small-12">{{phone.error.title}}</small>
					</div>
				</fieldset>
                <div class="small-12 sectionTitle flex">
					<h2>Unit Assignment</h2>
				</div>
                <fieldset class="small-12 flex inputGroup">
					<label class="small-12">Unit<em class="cRed">*</em></label>
					<div class="small-12 selectContainer borderRadius8 flex vertical-align">
                        <select name="units" class="small-12" v-model="unit.value">
                            <option :value="null" selected disabled>Please Choose...</option>
                            <option :value="unitObj.id" v-for="(unitObj, unitIndex) in units" :selected="unit.value == unitObj.id ? true : false" :key="unitIndex">{{unitObj.attributes.number}}</option>
                        </select>
                    </div>
					<div class="small-12 inputError flex animated fadeInDown borderRadius2" style="margin-top:5px;" v-if="unit.error.show">
						<small class="cRed small-12">{{unit.error.title}}</small>
					</div>
				</fieldset>
                <div class="small-12 sectionTitle flex">
					<h2>Additional Details</h2>
				</div>
                <fieldset class="small-12 flex inputGroup">
                    <div class="small-12 flex vertical-align">
                        <div class="auto">
                            <input type="checkbox" name="resides_in_unit" id="resides_in_unit" v-model="resides_in.value">
                            <label for="resides_in_unit"></label>
                        </div>
                        <span>Resides in Unit?</span>
                    </div>
					<div class="small-12 inputError flex animated fadeInDown borderRadius2" style="margin-top:5px;" v-if="resides_in.error.show">
						<small class="cRed small-12">{{resides_in.error.title}}</small>
					</div>
				</fieldset>
            </div>
        </div>
        <div class="small-12 columns panelActions flex justify-center vertical-align border-top">
            <a class="blueButton borderRadius4 flex justify-center vertical-align" @click="updateResidentHandler()" v-if="enableUpdateButton">
                <i class="material-icons-outlined addIcon borderRadius4 flex justify-center vertical-align">save</i>
                Save Resident
            </a>
            <a class="disabledButton borderRadius4 flex justify-center vertical-align" v-else>
                <i class="material-icons-outlined addIcon borderRadius4 flex justify-center vertical-align">save</i>
                Save Resident
            </a>
            <a class="deleteButton borderRadius4 flex justify-center vertical-align" v-if="enableDeleteButton">
                Delete Resident
            </a>
            <a class="deleteButton disabled borderRadius4 flex justify-center vertical-align" v-else>
                Delete Resident
            </a>
        </div>
    </div>
</template>

<script>

    // Import the events
    import { GetPropertyUnits } from '@/events/units/GetPropertyUnits'
    import { UpdateResident } from '@/events/residents/UpdateResident'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'EditResidentMenu',

		/*
		**  Register the components
		*/

		components: {

			//

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			GetPropertyUnits,
            UpdateResident

		],

		/*
		**  Set the props
		*/

		props: {

			menu_action: {
                type: Boolean,
                default: false
            },

            resident: {
                type: Object,
                default: () => null
            },

            property: {
                type: Object,
                default: () => null
            }

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			open_menu: false,
			edit_resident_processing: false,
            enableUpdateButton: false,
            enableDeleteButton: false,
            form_error: false,
            unit_number: null,
            edit_resident_form_props_set: false,
            first_name: {
                value: null,
                error: {
                    show: false,
                    title: null
                }
            },
            last_name: {
                value: null,
                error: {
                    show: false,
                    title: null
                }
            },
            email: {
                value: null,
                error: {
                    show: false,
                    title: null
                }
            },
            enrolled: {
                value: null,
                error: {
                    show: false,
                    title: null
                }
            },
            phone: {
                value: null,
                error: {
                    show: false,
                    title: null
                }
            },
            unit: {
                value: null,
                error: {
                    show: false,
                    title: null
                }
            },
            resides_in: {
                value: null,
                error: {
                    show: false,
                    title: null
                }
            }

		}),

		/*
		**  Watch em'
		*/

		watch: {

			menu_action: {

				immediate: true, // Load on created
				handler(menu_action) {

					/*
					**  Open the menu
					**  @method: @here
					*/

					if (menu_action) this.openTheMenu();

                    /*
					**  Open the menu
					**  @method: @Events/Units/GetPropertyUnits
					*/

                    if (menu_action) this.getPropertyUnitsHandler(this.$route.params.id);

				}

			},

            resident: {

				immediate: true, // Load on created
				handler(resident) {

					/*
					**  Set the form props
					**  @method: @here
					*/

					if (resident) this.setEditResidentFormProps();

				}

			},

            edited_first_name: {

				immediate: true, // Load on created
				handler(edited_first_name) {

					/*
					**  First name validation
					**  @method: @here
					*/

					if (edited_first_name && this.edit_resident_form_props_set) this.firstNameValidation();

				}

			},

            edited_last_name: {

				immediate: true, // Load on created
				handler(edited_last_name) {

					/*
					**  Last name validation
					**  @method: @here
					*/

					if (edited_last_name && this.edit_resident_form_props_set) this.lastNameValidation();

				}

			},

            edited_email: {

				immediate: true, // Load on created
				handler(edited_email) {

					/*
					**  Email validation
					**  @method: @here
					*/

					if (edited_email && this.edit_resident_form_props_set) this.emailValidation();

				}

			},

            edited_phone: {

				immediate: true, // Load on created
				handler(edited_phone) {

					/*
					**  Phone validation
					**  @method: @here
					*/

					if (edited_phone && this.edit_resident_form_props_set) this.phoneValidation();

				}

			},

            edited_unit: {

				immediate: true, // Load on created
				handler(edited_unit) {

					/*
					**  Unit validation
					**  @method: @here
					*/

					if (edited_unit && this.edit_resident_form_props_set) this.unitValidation();

				}

			}

		},

        /*
		**  Set up the methods
		*/

		methods: {

			openTheMenu: function() {

				try {

					/*
					**  Display the menu
					**  @prop: @here
					*/

					this.open_menu = true;
					
					/*
                    **  Reset validation props
                    **  @method: @here
                    */

                    this.resetEditResidentValidationProps();

                    /*
                    **  Set the form props
                    **  @method: @here
                    */

                    if (this.resident) this.setEditResidentFormProps();

				} catch (e) {

					/*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Open the Edit Resident Menu.',
                        errorType: 'Application',
                        section: 'Edit Resident Menu',
						uid: 'rXUdSRfhfkHUssFLvWk4',
                        error: e
                    });

				}

			},

            resetEditResidentValidationProps: function() {

                try {

                    /*
                    **  Reset the props
                    **  @props: @here
                    */

                    this.enableUpdateButton = false;
					this.enableDeleteButton = false;
                    this.edit_resident_form_props_set = false;
                    this.edit_resident_processing = false;
                    this.form_error = false;

                } catch (e) {

                    /*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Reset the validation props for the edit resident menu.',
						errorType: 'Application',
						section: 'Edit Resident Menu',
						uid: 'HKoJKjbCKRT3Xf2rSGBc',
						error: e
					});

                }

            },

            closeEditResidentMenu: function() {

                try {
 
					/*
                    **  Close the menu
					**  @prop: @here
					*/

					this.open_menu = false;

					/*
                    **  Emit the event
					**  @service: @Vue
					*/

					this.$emit('closeEditResidentMenu', true);

					/*
                    **  Reset the prop
					**  @method: @here
					*/

					this.resetEditResidentValidationProps();

				} catch (e) {

					/*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Close the Edit Resident Menu.',
                        errorType: 'Application',
                        section: 'Edit Resident Menu',
						uid: 'BqQW7i8pGpnHA7LpKQEo',
                        error: e
                    });

				}

            },

            setEditResidentFormProps: function() {

                try {

                    /*
                    **  Set the form props
                    **  @props: @here
                    */

                    this.first_name.value = this.resident.attributes.contact_information.first_name;
                    this.last_name.value = this.resident.attributes.contact_information.last_name;
                    this.email.value = this.resident.attributes.contact_information.email;
                    this.phone.value = this.resident.attributes.contact_information.phone_number;
                    this.unit.value = this.resident.relationships.unit;
                    this.resides_in.value = this.resident.attributes.unit.resides_in;
                    this.enrolled.value = this.resident.attributes.site_enrollment.enroll_resident;
                    this.unit_number = this.resident.attributes.unit.number;

                    /*
                    **  Complete the props setting
                    **  @props: @here
                    */

                    this.edit_resident_form_props_set = true;

                } catch (e) {

                    /*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Set the form props for the edit resident menu.',
						errorType: 'Application',
						section: 'Edit Resident Menu',
						uid: '2i6L9wFJA2xZnqzRBsDg',
						error: e
					});

                }

            },

            enableSubmitButtonCheck: function() {

                try {

                    if (!this.first_name.error.show && !this.last_name.error.show && !this.email.error.show && !this.phone.error.show && !this.unit.error.show && !this.resides_in.error.show) {

                        /*
						**  Enable the submit button
						**  @prop: @here
						*/

						this.enableUpdateButton = true;

					} else {

						/*
						**  Disable the submit button
						**  @prop: @here
						*/

						this.enableUpdateButton = false;

					}

                } catch (e) {

                    /*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Unable to perform submit button check.',
						errorType: 'Application',
						section: 'Edit Resident Menu',
						uid: 'X1krdJ6UrVIh4KQaBOMC',
						error: e
					});

                }

            },

            firstNameValidation: function(event) {

                try {

                    if (this.first_name.value == '' || !this.first_name.value || this.first_name.value.length == 0) {

                        /*
                        **  Set the error props
                        **  @props: @here
                        */

                        this.first_name.error.show = true;
                        this.first_name.error.title = 'This is a required field.';

                    } else {

                        /*
                        **  Set the error props
                        **  @props: @here
                        */

                        this.first_name.error.show = false;
                        this.first_name.error.title = null;

                    }

                    /*
					**  Check if we can enable the submit button
					**  @method: @here
					*/

					if (event) this.enableSubmitButtonCheck();

                } catch (e) {

                    /*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Unable to validate the first name.',
						errorType: 'Application',
						section: 'Edit Resident Menu',
						uid: 'kCg1xRVHuUOaXrZjPhwE',
						error: e
					});

                }

            },

            lastNameValidation: function(event) {

                try {

                    if (this.last_name.value == '' || !this.last_name.value || this.last_name.value.length == 0) {

                        /*
                        **  Set the error props
                        **  @props: @here
                        */

                        this.last_name.error.show = true;
                        this.last_name.error.title = 'This is a required field.';

                    } else {

                        /*
                        **  Set the error props
                        **  @props: @here
                        */

                        this.last_name.error.show = false;
                        this.last_name.error.title = null;

                    }

                    /*
					**  Check if we can enable the submit button
					**  @method: @here
					*/

					if (event) this.enableSubmitButtonCheck();

                } catch (e) {

                    /*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Unable to validate the last name.',
						errorType: 'Application',
						section: 'Edit Resident Menu',
						uid: 'tvurTtgLcCRBBGX3QRZ3',
						error: e
					});

                }

            },

            emailValidation: function(event) {

                try {

                    /*
                    **  Test the entry
                    */

                    let validEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(this.email.value);

                    /*
                    **  Run the validation
                    **  @props: @here
                    */

                    if (this.enrolled.value && this.email.value == '' || this.enrolled.value && !this.email.value || this.enrolled.value && this.email.value.length == 0) {

                        /*
                        **  Set the error props
                        **  @props: @here
                        */

                        this.email.error.show = true;
                        this.email.error.title = 'This is a required field.';

                    } else if (this.enrolled.value && !validEmail) {

                        /*
                        **  Set the error props
                        **  @props: @here
                        */

                        this.email.error.show = true;
                        this.email.error.title = 'Must be a valid email address.';
                        
                    } else {

                        /*
                        **  Set the error props
                        **  @props: @here
                        */

                        this.email.error.show = false;
                        this.email.error.title = null;

                    }

                    /*
					**  Check if we can enable the submit button
					**  @method: @here
					*/

					if (event) this.enableSubmitButtonCheck();

                } catch (e) {

                    /*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Unable to validate the email.',
						errorType: 'Application',
						section: 'Edit Resident Menu',
						uid: 'HsbL4960VKLvlZqRGhj5',
						error: e
					});

                }

            },

            phoneValidation: function() {

                try {

                    /*
                    **  Run the validation
                    **  @props: @here
                    */

                    if (this.phone.value && this.phone.value.length > 0) {

                        // Set the var
                        let x = this.phone.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);

                        // Format the phone number
                        this.phone.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');

                    }

                    /*
					**  Check if we can enable the submit button
					**  @method: @here
					*/

					this.enableSubmitButtonCheck();

                } catch (e) {

                    /*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Unable to validate the phone.',
						errorType: 'Application',
						section: 'Edit Resident Menu',
						uid: 'mJ39IBMY0zMxYe98HPav',
						error: e
					});

                }

            },

            unitValidation: function() {

                try {

                    /*
                    **  Get the chosen unit
                    */

                    let chosen_unit = this.units.filter((item)=>{

						return item.id.includes(this.unit.value);

					});

                    /*
                    **  Set the unit number
                    **  @prop: @here
                    */

                    if (chosen_unit && chosen_unit.length > 0) this.unit_number = chosen_unit[0].attributes.number;

                    /*
                    **  Run the validation
                    **  @props: @here
                    */

                    if (!this.unit.value || this.unit.value.length == 0 || this.unit.value == '') {

                        /*
                        **  Set the error props
                        **  @props: @here
                        */

                        this.unit.error.show = true;
                        this.unit.error.title = 'This is a required field.';

                    } else if (chosen_unit && chosen_unit.length > 0 && chosen_unit[0].relationships.resident !== this.resident.id) {

                        /*
                        **  Set the error props
                        **  @props: @here
                        */

                        this.unit.error.show = true;
                        this.unit.error.title = 'The unit chosen is already assigned to another resident.';

                    } else {

                        /*
                        **  Set the error props
                        **  @props: @here
                        */

                        this.unit.error.show = false;
                        this.unit.error.title = null;

                    }

                    /*
					**  Check if we can enable the submit button
					**  @method: @here
					*/

					this.enableSubmitButtonCheck();

                } catch (e) {

                    /*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Unable to validate the unit.',
						errorType: 'Application',
						section: 'Edit Resident Menu',
						uid: '8Y5k24Euse4jwhqfPTaT',
						error: e
					});

                }

            }

		},

		/*
		**  Set the computed props
		*/

		computed: {

			edited_first_name: function() {

				return this.first_name.value;

			},
            edited_last_name: function() {

				return this.last_name.value;

			},
            edited_email: function() {

				return this.email.value;

			},
            edited_phone: function() {

				return this.phone.value;

			},
            edited_unit: function() {

				return this.unit.value;

			},

		},

		/*
		**  Set the filters
		*/

		filters: {

			//

		}

	}

</script>